import { isValNull, getPath } from "../../utils";
import {evTypes} from "../DlRcDetails/DlRcDocumentDetailsEdit"
const excludeKeysForQcApproveButton = [
  "driver_dob",
  "face_match_data",
  "phone_match_data",
  "device_match_data",
  "aadhar_profile",
  "aadhar_card_doc",
  "driver_photo"
];

export const shouldQcApproved = (initialState) => {
  let showQc = true;
  if (Object.keys(initialState).length > 0) {
    Object.keys(initialState).forEach((outerKey) => {
      const details = initialState[outerKey];
      if (typeof details === "object") {
        Object.keys(details).forEach((innerKey) => {
          const keyDetails = details[innerKey];
          if (
            !isValNull(keyDetails) &&
            typeof keyDetails === "object" &&
            !excludeKeysForQcApproveButton.includes(innerKey) &&
            !keyDetails.verified && !keyDetails.idfy_verified
          ) {
            if(innerKey === "pucc_doc" && evTypes.includes(getPath(initialState, "document_details.rc_doc.fuel_type", ""))){
              return;
            }
            showQc = false;
          }
        });
      }
    });
    return showQc;
  }
  return false;
};